export default __webpack_public_path__ + "static/media/Plant-icon.ff605ad1.svg";